import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/LeasedEquipmentConfiguration";

export const getLeasedEquipmentStatusList = async () => {
  return axios.get(`${api_base_url}/GetStatus`).then((res) => {
    return res;
  });
};

export const addLeasedEquipmentStatus = async (newStatus) => {
  const { data } = await axios.post(`${api_base_url}/AddStatus`, {
    ...newStatus,
  });
  return data;
};

export const deleteLeasedEquipmentStatus = async (ids) => {
  const { data } = await axios.delete(`${api_base_url}/DeactivateStatus`, {
    data: ids,
  });
  return data;
};

export const updateLeasedEquipmentStatus = async (
  editLeasedEquipmentStatus
) => {
  const { data } = await axios.put(`${api_base_url}/EditStatus`, {
    ...editLeasedEquipmentStatus,
  });
  return data;
};
